import { ReactComponent as InstagramSVG } from "@images/instagram-white.svg";
import { ReactComponent as FacebookSVG } from "@images/facebook-white.svg";
import { ReactComponent as TwitterSVG } from "@images/twitter-white.svg";
import { Sanity } from "@models/sanity.model";
import { Container } from "./DetailSocial.styled";

export interface DetailSocialProps {
  content: Sanity.Social;
}

const DetailSocial = ({ content }: DetailSocialProps) => {
  return (
    <Container>
      <ul>
        {content.instagram_url && (
          <li>
            <a href={content.instagram_url} target="_blank" rel="noreferrer">
              <InstagramSVG />
            </a>
          </li>
        )}
        {content.facebook_url && (
          <li>
            <a href={content.facebook_url} target="_blank" rel="noreferrer">
              <FacebookSVG />
            </a>
          </li>
        )}
        {content.twitter_url && (
          <li>
            <a href={content.twitter_url} target="_blank" rel="noreferrer">
              <TwitterSVG />
            </a>
          </li>
        )}
      </ul>
    </Container>
  );
};

export default DetailSocial;
